
import Splide from '@splidejs/splide'
import Icon from '@/components/UntitledUI/Icon.vue'

export default {
    components: { Icon },
    props: {
        category: {
            required: true,
            type: Object
        },
        id: {
            required: true,
            type: String
        },
        isSlider: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            splide: null,
            loading: false,
            hasMore: true,
            filteredItems: this.category.category_items,
            page: 1
        }
    },
    computed: {
        displayedItems () {
            if (this.category.type === 'saudi_update') {
                if (this.category.category_items.length === 0) {
                    return []
                }
                return this.category.category_items[0].items
            }
            return this.category.category_items
        }
    },
    mounted () {
        this.init()
        window.addEventListener('scroll', this.handleScroll)
    },
    updated () {
        this.init()
    },
    beforeDestroy () {
        this.destroy()
        window.removeEventListener('scroll', this.handleScroll)
    },
    methods: {
        destroy () {
            if (this.splide) {
                this.splide.destroy()
            }
        },
        init () {
            this.destroy()
            if (!this.isSlider) {
                return
            }
            const options = {
                arrows: true,
                focus: 0,
                autoWidth: true,
                pagination: true,
                omitEnd: true,
                type: 'slide',
                direction: this.$helpers.getDir()
            }
            this.splide = new Splide(`#${this.id}`, options)
            this.splide.mount({})
        },
        formatDate (date) {
            return new Date(date).toLocaleDateString('ar-US', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            })
        },
        handleScroll () {
            const bottomOfWindow =
                document.documentElement.scrollTop + window.innerHeight >=
                document.documentElement.offsetHeight - 100

            if (bottomOfWindow && !this.loading && this.hasMore) {
                this.loadMoreItems()
            }
        },
        loadMoreItems () {
            this.loading = true
            this.$axios
                .$get(`v1/categories/${this.category.id}/load-items`, {
                    params: {
                        page: this.page + 1
                    }
                })
                .then((res) => {
                    if (res.category_items.length > 0) {
                        this.filteredItems = [...this.filteredItems, ...res.category_items]
                        this.page += 1
                    } else {
                        this.hasMore = false
                    }
                })
                .catch((e) => {
                    console.error('Error fetching more items:', e)
                })
                .finally(() => {
                    this.loading = false
                })
        }
    }
}

